import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Input,
  InputAdornment,
  Box,
} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import BlockIcon from "@material-ui/icons/Block";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { DatePicker } from "@material-ui/pickers";
import { usePermission } from "../../components/usePermission";
import Loader from "../../components/Control/Loader";
import formatDate from "../../components/Control/formatDate";
import useConfirm from "../../components/Control/useConfirm";
import { useAuth } from "../../context/GlobalContext";
import { useQuery } from "../../components/Control/useQuery";
import ItemsDetailsHeader from "../../GlobalUtils/ItemsDetailsHeader";
import formatYearRange from "../../../helpers/formatDateRange";
import SearchSharp from "@material-ui/icons/SearchSharp";

const useStyles = makeStyles({
  table: {
    width: "100%",
    marginTop: "1.5rem",
    backgroundColor: "white",
  },
});
const Editable = ({ item, DeletePir, partId }) => {
  const query = useQuery();
  const permissions = usePermission(22);
  const partNumber = query.get("partNumber");
  const partName = query.get("partName");
  return (
    <TableCell align="center">
      <Tooltip title="PIR" arrow>
        {permissions?.includes("view") ? (
          <Link
            to={`/supervisor/CreateEditPir/${partId}/${item._id}?partNumber=${partNumber}&partName=${partName}&isView=true`}
          >
            <IconButton size="small">
              <VisibilityIcon
                style={{ fontSize: "1.4rem", color: "#003566" }}
              />
            </IconButton>
          </Link>
        ) : (
          <BlockIcon style={{ color: "#c92a2a" }} />
        )}
      </Tooltip>

      {permissions?.includes("edit") && (
        <Tooltip title="Edit" arrow>
          <Link
            to={`/supervisor/CreateEditPir/${partId}/${item._id}?partNumber=${partNumber}&partName=${partName}&isView=false`}
          >
            <IconButton size="small" style={{ marginLeft: "0.5rem" }}>
              <EditIcon style={{ fontSize: "1.4rem", color: "#003566" }} />
            </IconButton>
          </Link>
        </Tooltip>
      )}
      {permissions?.includes("delete") && (
        <Tooltip title="Delete" arrow>
          <IconButton
            size="small"
            style={{ marginLeft: "0.5rem" }}
            onClick={() => DeletePir(item._id)}
          >
            <DeleteIcon
              style={{
                fontSize: "1.4rem",
                color: "red",
              }}
            />
          </IconButton>
        </Tooltip>
      )}
    </TableCell>
  );
};
const NotEditable = ({ item, partId }) => {
  const query = useQuery();
  const partNumber = query.get("partNumber");
  const partName = query.get("partName");
  const permissions = usePermission(22);

  return (
    <TableCell align="center">
      <Tooltip title="PIR" arrow>
        {permissions?.includes("view") ? (
          <Link
            to={`/supervisor/CreateEditPir/${partId}/${item._id}?partNumber=${partNumber}&partName=${partName}&isView=true`}
          >
            <IconButton size="small">
              <VisibilityIcon
                style={{ fontSize: "1.4rem", color: "#003566" }}
              />
            </IconButton>
          </Link>
        ) : (
          <BlockIcon style={{ color: "#c92a2a" }} />
        )}
      </Tooltip>
      <Tooltip title="Block" arrow>
        <IconButton size="small" style={{ marginLeft: "0.5rem" }}>
          <BlockIcon
            style={{
              fontSize: "1.4rem",
              color: "red",
            }}
          />
        </IconButton>
      </Tooltip>
      <Tooltip title="Block" arrow>
        <IconButton size="small" style={{ marginLeft: "0.5rem" }}>
          <BlockIcon
            style={{
              fontSize: "1.4rem",
              color: "red",
            }}
          />
        </IconButton>
      </Tooltip>
    </TableCell>
  );
};

const superviserStatus = (
  partId,
  item,
  isSubmit,
  adminRequestStatus,
  DeletePir,
  DialogDelete
) => {
  //notsubmitted
  if (!isSubmit) {
    return (
      <>
        <TableCell
          align="center"
          style={{
            backgroundColor: "#1864ab",
            color: "white",
          }}
        >
          <span>SAVED</span>
        </TableCell>
        <Editable item={item} DeletePir={DeletePir} partId={partId} />
        <DialogDelete isSubmitContent={false} />
      </>
    );
  }

  if (adminRequestStatus === "pending" && isSubmit) {
    return (
      <>
        <TableCell
          align="center"
          style={{
            backgroundColor: "#fdd835",
            color: "black",
            maxWidth: "200px",
          }}
        >
          <span
            style={{
              display: "flex",
              width: "100%",
              alignItems: "Center",
              justifyContent: "center",
              gap: "1rem",
            }}
          >
            PENDING FOR APPROVAL
          </span>
        </TableCell>
        <NotEditable item={item} partId={partId} />
      </>
    );
  }
  if (adminRequestStatus === "accepted" && isSubmit) {
    return (
      <>
        <TableCell
          align="center"
          style={{
            backgroundColor: "#2b8a3e",
            color: "#fff",
          }}
        >
          <span>APPROVED</span>
        </TableCell>
        <NotEditable item={item} />
      </>
    );
  }

  if (adminRequestStatus === "rejected" && isSubmit) {
    return (
      <>
        <TableCell
          align="center"
          style={{
            backgroundColor: "#f03e3e",
            color: "#fff",
          }}
        >
          <span>SENT BACK FOR RECHECKING</span>
        </TableCell>
        <Editable item={item} DeletePir={DeletePir} partId={partId} />
      </>
    );
  }
};

function ViewMonthyPirSupervisor() {
  const { partId } = useParams();
  const classes = useStyles();
  const [pirListData, setPirListData] = useState(null);
  const [render, setRender] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const { state } = useAuth();
  const query = useQuery();
  const partNumber = query.get("partNumber");
  const partName = query.get("partName");
  const permissions = usePermission(22);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");

  const [DialogDelete, confirmDelete] = useConfirm(
    "DELETE PIR",
    "Are you sure you want to delete this PIR?"
  );

  const fetchPirList = (searchValue = "") => {
    if (selectedDate) {
      setIsLoading(true);
      axios
        .get(`/api/getMonthlyPirList/supervisor/${partId}/${selectedDate}`, {
          params: { search: searchValue },
        })
        .then((res) => {
          setPirListData(
            res.data.sort((a, b) =>
              a.pirReport_date.localeCompare(b.pirReport_date)
            )
          );
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    fetchPirList();
  }, [render, selectedDate]);

  const DeletePir = async (id) => {
    let isDeleted = await confirmDelete();
    if (isDeleted) {
      axios
        .delete(`/api/deleteOnePir/${id}`)
        .then(() => {
          setRender((prev) => !prev);
        })
        .catch((err) => {
          console.log(err);
        });
      return;
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div style={{ paddingBottom: "3rem" }}>
      <div
        className="divflex"
        style={{
          fontSize: "24px",
        }}
      >
        <span>PROCESS INSPECTION REPORT</span>
        <div style={{}}>
          {permissions?.includes("edit") && (
            <Link
              to={`/supervisor/CreateEditPir/${partId}?partNumber=${partNumber}&partName=${partName}&isView=false`}
              style={{ color: "white", textDecoration: "none" }}
            >
              <Button
                variant="contained"
                color="primary"
                size="large"
                style={{ backgroundColor: "#054a29" }}
                startIcon={<AddCircleIcon />}
              >
                New REPORT
              </Button>
            </Link>
          )}
        </div>
      </div>
      <ItemsDetailsHeader itemNum={partNumber} itemDesc={partName} />

      <div className="subheading-container">
        <p className="subheading-primary">
          ACTIVE <span className="subheading-secondary">REPORTS</span>
        </p>
      </div>
      <div style={{ marginTop: "2rem", marginLeft: "1rem" }}>
        <DatePicker
          views={["year"]}
          label="Year"
          className="date-field"
          inputVariant="filled"
          value={selectedDate}
          onChange={setSelectedDate}
        />
      </div>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.75rem",
          margin: "1rem 0 0 1.2rem",
          maxWidth: "680px",
        }}
      >
        <Input
          placeholder="Search Item No., PO No., or Machine No."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") fetchPirList(search);
          }}
          startAdornment={
            <InputAdornment position="start">
              <SearchSharp />
            </InputAdornment>
          }
          style={{ flex: 1 }}
        />
        <Button variant="contained" onClick={() => fetchPirList(search)}>
          Search
        </Button>
      </Box>
      <Table className={classes.table} size="small">
        <TableHead>
          <TableRow style={{ padding: "6px" }}>
            <TableCell style={{ fontWeight: "bold" }} align="center">
              #
            </TableCell>
            <TableCell style={{ fontWeight: "bold" }} align="center">
              Item Number
            </TableCell>
            <TableCell style={{ fontWeight: "bold" }} align="center">
              Username
            </TableCell>
            <TableCell style={{ fontWeight: "bold" }} align="center">
              Machine No.
            </TableCell>
            <TableCell style={{ fontWeight: "bold" }} align="center">
              PO No.
            </TableCell>
            <TableCell style={{ fontWeight: "bold" }} align="center">
              RM MRN No.
            </TableCell>
            <TableCell style={{ fontWeight: "bold" }} align="center">
              Date
            </TableCell>
            <TableCell style={{ fontWeight: "bold" }} align="center">
              Status
            </TableCell>
            <TableCell style={{ fontWeight: "bold" }} align="center">
              Action
            </TableCell>
          </TableRow>
        </TableHead>
        {pirListData && (
          <TableBody>
            {pirListData.map((item, index) => (
              <React.Fragment key={item._id}>
                <TableRow className={classes.rootRow}>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="center">
                    {item.part_id?.part_number}
                  </TableCell>
                  <TableCell
                    style={{ textTransform: "capitalize" }}
                    align="center"
                  >
                    {item.report_prepared_by}
                  </TableCell>
                  <TableCell align="center">{item.mc_no || "-"}</TableCell>
                  <TableCell align="center">{item.po_no || "-"}</TableCell>
                  <TableCell align="center">
                    {item.rm_mrm
                      ? `${formatYearRange(item.pirReport_date, true, true)}/${item.rm_mrm}`
                      : "-"}
                  </TableCell>
                  <TableCell align="center">
                    {formatDate(item.pirReport_date)}
                  </TableCell>
                  {superviserStatus(
                    partId,
                    item,
                    item.isSubmitted,
                    item.is_admin_request,
                    DeletePir,
                    DialogDelete
                  )}
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        )}
      </Table>
    </div>
  );
}

export default ViewMonthyPirSupervisor;
